import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OnBoardingDashboardComponent } from './on-boarding-dashboard/on-boarding-dashboard.component';
import { AuthGuard } from '../shared/auth-guard';
const routes: Routes = [
    // { path: 'on-boarding-dashboard', component: OnBoardingDashboardComponent}
]
@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class OnBoardingRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/on-boarding/on-boarding-routing.module.ts